import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import styles from './button.css'

function Button({
  wrapperClassName,
  className,
  secondary,
  darkBGSecondary,
  lightBGPrimary,
  outlined,
  disabled,
  onClick,
  text,
  error,
  isRental,
  e2eIdentifier,
  children
}) {
  const classes = classNames(
    styles.button,
    {
      [styles.secondary]: secondary,
      [styles.darkBGSecondary]: darkBGSecondary,
      [styles.lightBGPrimary]: lightBGPrimary,
      [styles.outlined]: outlined,
      [styles.isRental]: isRental
    },
    className
  )

  return (
    <div className={wrapperClassName}>
      {
        onClick
          ? (
            <button // eslint-disable-line jsx-a11y/no-static-element-interactions
              onClick={onClick}
              className={classes}
              data-lbx-e2e={e2eIdentifier}
              disabled={disabled}
            >
              {children || text}
            </button>
          )
          : (
            <button
              type="submit"
              data-lbx-e2e={e2eIdentifier}
              className={classes}
              disabled={disabled}
            >
              {children || text}
            </button>
          )
      }
      <span className={styles.warning}>{error}</span>
    </div>
  )
}

Button.propTypes = {
  className: PropTypes.string,
  secondary: PropTypes.bool,
  darkBGSecondary: PropTypes.bool,
  lightBGPrimary: PropTypes.bool,
  outlined: PropTypes.bool,
  disabled: PropTypes.bool,
  text: PropTypes.string,
  children: PropTypes.node,
  error: PropTypes.string,
  onClick: PropTypes.func,
  wrapperClassName: PropTypes.string,
  isRental: PropTypes.bool,
  e2eIdentifier: PropTypes.string
}

Button.defaultProps = {
  className: null,
  secondary: false,
  darkBGSecondary: false,
  lightBGPrimary: false,
  outlined: false,
  disabled: false,
  text: null,
  children: null,
  onClick: null,
  error: null,
  isRental: false,
  wrapperClassName: '',
  e2eIdentifier: ''
}

export default Button
